import * as z from "zod/v4";

export const getClaimsMetrics = {
  name: "getClaimsMetrics" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    totalRevenueClaimed: z.number(),
    totalResolvedClaims: z.number(),
    approvalRate: z.number(),
    proactiveClaimsSubmitted: z.number(),
    allTimeApprovalRate: z.number(),
    avgTimeToResolutionDays: z.number(),
  }),
};
